/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { MyPermissionsResponse } from '../../models/my-permissions-response';

export interface AuthzMyPermissions$Plain$Params {
}

export function authzMyPermissions$Plain(http: HttpClient, rootUrl: string, params?: AuthzMyPermissions$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<MyPermissionsResponse>> {
  const rb = new RequestBuilder(rootUrl, authzMyPermissions$Plain.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<MyPermissionsResponse>;
    })
  );
}

authzMyPermissions$Plain.PATH = '/api/v1/auth/me/permissions';
